// Generated by CoffeeScript 2.7.0
var DynamicDatePicker, dynamic_list_comp, ref;

dynamic_list_comp = {
  props: {
    extendClass: {
      type: String
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    listName: {
      type: String
    },
    animationDuration: {
      type: Number,
      default: 300
    },
    itemWidth: {
      type: Number,
      default: 29
    }
  },
  data: function() {
    return {
      selected: this.list[0],
      timer: null
    };
  },
  template: `<div class="list"
     :class="extendClass"
     ref='list'>
  <template v-if="list.length">
    <div class="list-item"
         v-for="(item, index) in list"
         :key="item.key"
         :class="{ 'selected': selected == item }"
         @click="select(index)">
      <span>{{item.text}}</span>
    </div>
  </template>
  <template v-else>
    <div class="list-item disabled">
      <span>空</span>
    </div>
  </template>
</div>`,
  computed: {
    deltaY: function() {
      return this.itemWidth * this.selectedIndex;
    },
    selectedIndex: function() {
      return _.indexOf(this.list, this.selected);
    }
  },
  methods: {
    select: function(index) {
      var ref;
      this.selected = this.list[index];
      this.scrollItemIntoView();
      return this.$emit('valueChange', ((ref = this.selected) != null ? ref.key : void 0) || '', this.listName);
    },
    scrollItemIntoView: function() {
      var _list, _start_scrollTop, _start_time, func;
      cancelAnimationFrame(this.timer);
      _list = this.$refs.list;
      _start_time = new Date();
      _start_scrollTop = _list.scrollTop;
      return this.timer = requestAnimationFrame(func = () => {
        var _t;
        _t = this.animationDuration - Math.max(0, _start_time - new Date() + this.animationDuration);
        _list.scrollTop = _t * (this.deltaY - _start_scrollTop) / this.animationDuration + _start_scrollTop;
        this.timer = requestAnimationFrame(func);
        if (_t === this.animationDuration) {
          return cancelAnimationFrame(this.timer);
        }
      });
    },
    reset: function() {
      switch (this.listName) {
        case 'timespan':
          if (this.selected.key > (_.last(this.list)).key) {
            return this.select(0);
          } else {
            return this.select(this.selected.key - 1);
          }
          break;
        case 'addition':
          return this.select(0) || null;
      }
    },
    setValue: function(value = (ref = this.list[0]) != null ? ref.key : void 0) {
      var ref1;
      this.selected = _.find(this.list, function(item) {
        var ref1;
        return ((ref1 = item.key) != null ? ref1.toString() : void 0) === (value != null ? value.toString() : void 0);
      });
      this.scrollItemIntoView();
      return this.$emit('valueChange', ((ref1 = this.selected) != null ? ref1.key : void 0) || '', this.listName);
    }
  }
};

export default DynamicDatePicker = Vue.extend({
  components: {
    'dynamic-list': dynamic_list_comp
  },
  data: function() {
    return {
      value: {
        period: '-',
        timespan: 1,
        dimension: 'd',
        addition: ''
      }
    };
  },
  template: `<div class="dynamicdatepicker">
  <div class="picker-view-container">
    <dynamic-list extendClass="picker-item"
                v-for="(list, key) in list"
                :key="key"
                :list="list"
                :listName="key"
                @valueChange='updateValue'
                ref="dynamicListRef" />
  </div>
</div>`,
  computed: {
    periodKeyList: function() {
      return ['过去', '当前', '未来'];
    },
    spanKeyList: function() {
      if (!this.value.period) {
        return [1];
      } else {
        switch (this.value.dimension) {
          case 'd':
            return (function() {
              var results = [];
              for (var i = 1; i < 32; i++){ results.push(i); }
              return results;
            }).apply(this);
          case 'w':
            return (function() {
              var results = [];
              for (var i = 1; i < 53; i++){ results.push(i); }
              return results;
            }).apply(this);
          case 'm':
            return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
          default:
            return [1];
        }
      }
    },
    dimensionKeyList: function() {
      return ['天', '周', '月'];
    },
    additionKeyList: function() {
      switch (this.value.dimension) {
        case 'w':
          return ['一', '二', '三', '四', '五', '六', '日'];
        case 'm':
          return (function() {
            var results = [];
            for (var i = 1; i < 32; i++){ results.push(i); }
            return results;
          }).apply(this);
        default:
          return [];
      }
    },
    list: function() {
      return {
        period: this.periodList,
        timespan: this.timespanList,
        dimension: this.dimensionList,
        addition: this.additionList
      };
    },
    periodList: function() {
      var _result;
      _result = _.map(this.periodKeyList, function(period) {
        var value;
        value = (function() {
          switch (period) {
            case '过去':
              return '-';
            case '当前':
              return '';
            case '未来':
              return '+';
          }
        })();
        return {
          text: period,
          key: value
        };
      });
      return _result;
    },
    timespanList: function() {
      return _.map(this.spanKeyList, function(timespan) {
        return {
          text: timespan,
          key: timespan
        };
      });
    },
    dimensionList: function() {
      return _.map(this.dimensionKeyList, function(dimension) {
        var value;
        value = (function() {
          switch (dimension) {
            case '天':
              return 'd';
            case '周':
              return 'w';
            case '月':
              return 'm';
          }
        })();
        return {
          text: dimension,
          key: value
        };
      });
    },
    additionList: function() {
      var _result;
      _result = _.map(this.additionKeyList, (addition, index) => {
        return {
          text: (function() {
            switch (this.value.dimension) {
              case 'w':
                return '星期' + addition;
              case 'm':
                return addition + '日';
              default:
                return '';
            }
          }).call(this),
          key: index + 1
        };
      });
      switch (this.value.dimension) {
        case 'w':
          return [
            {
              text: '空',
              key: ''
            }
          ].concat(_result);
        case 'm':
          return [
            {
              text: '空',
              key: ''
            }
          ].concat(_result).concat([
            {
              text: '最后1日',
              key: '-1'
            }
          ]);
        default:
          return _result;
      }
    },
    dynamicValue: function() {
      return _.chain(this.value).values().join('').value();
    }
  },
  methods: {
    updateValue: function(newValue, name) {
      this.value[name] = newValue;
      this.$nextTick(function() {
        return this.resetList(name);
      });
      return this.$emit('valueChanged', this.dynamicValue);
    },
    resetList: function(changedListName) {
      var ref1, ref2, ref3;
      switch (changedListName) {
        case 'period':
          // reset timespan
          return (ref1 = this.$refs.dynamicListRef[1]) != null ? ref1.reset() : void 0;
        case 'dimension':
          // reset tiemspan and addition
          if ((ref2 = this.$refs.dynamicListRef[1]) != null) {
            ref2.reset();
          }
          return (ref3 = this.$refs.dynamicListRef[3]) != null ? ref3.reset() : void 0;
      }
    },
    setDate: function(dynamic_date) {
      var _match_string;
      _match_string = dynamic_date != null ? dynamic_date.match(/([\+|\-]?)(\d{1,2})([d|w|m])(\-?\d{0,2})/ || null) : void 0;
      return _.each(this.$refs.dynamicListRef, function(vm, index) {
        return vm.setValue(_match_string != null ? _match_string[index + 1] : void 0);
      });
    }
  }
});
